<template>
  <div ref="pageView" class="page-view">
    <application-content></application-content>
  </div>
</template>

<script>
// components
import applicationContent from "./components/applicationContent.vue";
export default {
  components: { applicationContent },
  data() {
    return {
      loading: false,
      detailData: {},
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.page-view {
  height: 100%;
  overflow: auto;
}
</style>
